import React from 'react';
import Modal from 'react-modal';
import { observer } from 'mobx-react';
import useModalStore from 'hooks/useModalStore';

Modal.setAppElement('#root');

const ConfirmModal = observer(({ option }) => {
  const modalStore = useModalStore();

  if (!option) {
    return (<></>);
  }

  return (
    <Modal
      isOpen={option.isOpen}
      onRequestClose={() => {
        modalStore.closeModal();
      }}
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)'
        }
      }}
    >

      <h2>{option.title}</h2>
      <div dangerouslySetInnerHTML={ {__html: option.message.replace(/\n/g, '<br/>')} } />

      <button onClick={() => {
        modalStore.okModal();
      }}>ok</button>&nbsp;
      <button onClick={() => {
        modalStore.closeModal();
      }}>close</button>
    </Modal>
  );
});

export {
  ConfirmModal
};
